<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <label class="w-100 ml-3 mb-3" style="color: #17A2B8 !important; font-size: 1em;">{{ nombreTratamiento }}</label>

    <div class="d-flex justify-content-center" v-if="datos.videoVista !== null">
      <div class="video-player">
        <video ref="videoPlayer" :src="datos.videoVista" @click="togglePlay" @play="handlePlay" @pause="handlePause"
               @mouseenter="handleMouseEnter" @mouseleave="handleMouseLeave"></video>
        <b-button v-if="showButton" class="play-button" @click="togglePlay" @mouseenter="handleMouseEnter"
                  @mouseleave="handleMouseLeave">
          <b-icon font-scale="6" :icon="isPlaying ? 'pause-fill':'play-fill'"></b-icon>
        </b-button>
      </div>
    </div>

    <br>
    <br>

    <b-row>
      <b-col cols="7">
        <div class="ml-3" v-html="datos.textoInformativo"></div>
      </b-col>
      <b-col cols="5">
        <div v-if="datos.imagenVista !== null">
          <img :src="datos.imagenVista" alt="img" style="height: 240px"/>
        </div>
      </b-col>
    </b-row>

  </div>
</template>

<script>
export default {
  name: "informacionArgumentario",
  props: {
    idTratamiento: Number,
    nombreTratamiento: String
  },
  data: () => {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
      mostrarModal: false,
      isPlaying: false,
      showButton: false,
      loader: false,
      datos: {
        imagenVista: null,
        videoVista: null,
        textoInformativo: null
      }
    }
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.obtenerArgumentarioTx();
  },
  methods: {
    obtenerArgumentarioTx() {
      this.loader = true;

      const params = {
        idTratamiento: this.idTratamiento
      }
      this.$http.post(this.$api + 'argumentario/obtenerArgumentarioTx', params).then(response => {
        if (response.data.data) {
          this.datos = response.data.data;
        }
      }).catch(error => {
        console.error(error);
      }).finally(() => {
        this.loader = false;
      })
    },
    togglePlay() {
      if (this.isPlaying) {
        this.$refs.videoPlayer.pause();
      } else {
        this.$refs.videoPlayer.play();
      }
    },
    handlePlay() {
      this.isPlaying = true;
    },
    handlePause() {
      this.isPlaying = false;
    },
    handleMouseEnter() {
      this.showButton = true;
    },
    handleMouseLeave() {
      this.showButton = false;
    },
  }
}
</script>

<style scoped>
.video-player {
  position: relative;
  //width: 100%;
  width: 70%;
  height: 0;
  //padding-bottom: 56.25%; /* para un aspecto de 16:9 */
  padding-bottom: 40%; /* para un aspecto de 16:9 */
  background: black;
}

.video-player video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.video-player .play-button {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 50px;
  color: white;
  background: transparent;
  border: none;
  pointer-events: none;
  cursor: pointer;
}
</style>